import styled from "styled-components";

export const MintModalPhaseOne = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
`

export const TitleText = styled.span`  
  font-family: "BebasNeue";
  font-size: 50px;
  line-height: 1;
  letter-spacing: 1px;
  margin: 0;
`

export const Skull = styled.img`
  width: 5vh;  
`

export const Arrow = styled.img`
  width: 5vh;
  transform: rotate(-90deg);
`

export const Content = styled.span`
  display: flex;
  font-family: "BebasNeue";
  font-size: 50px;
  line-height: 1;
  letter-spacing: 1px;
  text-align: center;  
  margin-top: 40px;
`

export const Footer = styled.p`
  display: flex;
  font-family: "NeueMachina";
  font-size: 15px;
  line-height: 1;
  letter-spacing: 1px;
  text-align: center;
  justify-content: center;
  margin: 0;
  margin-top: 20px;

  a {
    color: white;
    text-decoration: underline;

  }

  a:active {
    color: white;
  }

  a:visited {
    color: white;
  }  
`
